exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main[data-v-39336072] {\n  height: calc(100% - 52px);\n}\n.flag-btn[data-v-39336072] {\n  background: transparent;\n  border: 0px;\n  cursor: pointer;\n}\n", ""]);

// exports
